import { render, staticRenderFns } from "./ArticleDetailPage.vue?vue&type=template&id=2e786ddd&"
import script from "./ArticleDetailPage.vue?vue&type=script&lang=js&"
export * from "./ArticleDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports